import { render, staticRenderFns } from "./ReleaseStaffLink.vue?vue&type=template&id=36f73378&scoped=true&"
import script from "./ReleaseStaffLink.vue?vue&type=script&lang=ts&"
export * from "./ReleaseStaffLink.vue?vue&type=script&lang=ts&"
import style0 from "./ReleaseStaffLink.vue?vue&type=style&index=0&id=36f73378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f73378",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow})
